import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment/min/moment.min';
import { getSeason } from '../../../../lib/seasons';
import styles from './styles.scss';

export class Message extends PureComponent {
  static getGreeting() {
    const now = moment();
    const midday = moment('12:00pm', 'hh:mma');
    if (now.isBefore(midday)) {
      return 'Good morning';
    }

    return 'Good afternoon';
  }

  constructor(props) {
    super(props);

    const season = getSeason(Date.now());

    let greeting;
    if (season && season.greeting) {
      greeting = season.greeting; // eslint-disable-line prefer-destructuring
    } else if (this.firstClockIn()) {
      greeting = 'Welcome to Tanda';
    } else {
      greeting = Message.getGreeting();
    }

    this.state = { greeting };
  }

  showCurrentClockinStatus() {
    return this.props.currentUser.userLevels &&
           this.props.currentUser.userLevels.includes('employee');
  }

  firstClockIn() {
    return this.props.config && this.props.config.adminFirstClockIn;
  }

  clockInPrompt() {
    if (this.firstClockIn()) {
      return null;
    } else if (this.showCurrentClockinStatus()) {
      const status = this.props.currentUser.clockedIn ? 'in' : 'out';

      return (
        <p className={styles.Context__status}>
          <span>You are currently </span>
          <span className={styles['Context__status--bold']}>
            clocked {status}
          </span>.
        </p>
      );
    }

    return null;
  }

  render() {
    return (
      <div className={styles.Context}>
        <p className={styles.Context__greeting}>
          {this.state.greeting}, {this.props.currentUser.name}
        </p>

        {this.clockInPrompt()}
      </div>
    );
  }
}


Message.propTypes = {
  config: PropTypes.shape({
    adminFirstClockIn: PropTypes.bool,
  }).isRequired,
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    clockedIn: PropTypes.bool,
    userLevels: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/home/message.jsx